// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__R3IPg","menu-content":"styles_menu-content__zEQen","btn-menu":"styles_btn-menu__pnQdK","btn-exit":"styles_btn-exit__Pv5wc"};